import { render, staticRenderFns } from "./Calc2.vue?vue&type=template&id=6ff3a1dc&scoped=true&"
import script from "./Calc2.ts?vue&type=script&lang=ts&"
export * from "./Calc2.ts?vue&type=script&lang=ts&"
import style0 from "./Calc2.css?vue&type=style&index=0&id=6ff3a1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3a1dc",
  null
  
)

export default component.exports